import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { SectorService } from '../../sector/services/sector.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-sector-filter',
    templateUrl: './sector-filter.component.html',
    styleUrls: ['./sector-filter.component.scss'],
    imports: [ReactiveFormsModule, NgSelectModule]
})
export class SectorFilterComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() sectors;
  sectorSelect;
  @Output() sectorSelected = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }
}
